import { atom } from 'recoil';
import { PlanType } from '../../domain/Plan';

export const currentPlanState = atom<PlanType | null>({
  key: 'currentPlanState',
  default: null,
});
